<template>
  <div class="p-42 my-52 insights-container">
    <div class="relative">
      <div class="absolute-header" style="top: -20px">
        <div class="flex">
          <img
            style="width: 60px; height: 60px"
            src="../../assets/images/wv-monthly-insights/favicon.png"
            alt=""
          />
          <div class="py-6 ml-16 fs-20 fc-000000">
            <div class="fw-900">
              {{ $t("weMonthlyInsights.monthly.yourMonthlyInsights") }}
              {{ user.month }} {{ user.year }}
            </div>
            <div class="fs-18 pt-2">
              {{ $t("weMonthlyInsights.monthly.createdfor") }} {{ user.name }}
            </div>
          </div>
        </div>
      </div>
      <div @click.prevent="showVideo" class="absolute-header" style="top: -17px; right: 0">
        <div class="button-header flex-mid">
          <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
    <div class="mt-52 fs-16 fc-000000">
      {{ $t("weMonthlyInsights.monthly.hereIsYour") }}
      <span v-if="lang == 'TH'"> {{ user.month }} {{ user.year }}</span>
      <span v-else> {{ user.month }} {{ user.year }}.</span
      ><span v-if="user.boss">
        {{ $t("weMonthlyInsights.monthly.weRecommendThatboss") }}</span
      >
      <span v-else> {{ $t("weMonthlyInsights.monthly.weRecommendThat") }}</span>
    </div>
    <div class="fw-900 fs-18 fc-15253C mt-38">
      {{ $t("weMonthlyInsights.monthly.yourContributions") }}
    </div>
    <div class="mt-14 flex-wrap">
      <div class="flex-center contributions-card">
        <img
          :src="
            require(`@/assets/images/wv-monthly-insights/monthly/${
              contributionsData.dailyAttendanceStatus || 'red'
            }/ic_daily_attendance.png`)
          "
          class="big-circle"
        />
        <div class="fs-13 ml-8">
          <div class="fw-700">
            {{
              contributionsData.dailyAttendance>0
                ? $utils(
                    "addCommasInNumber",
                    contributionsData.dailyAttendance.toFixed(0) || ""
                  )
                : "-"
            }}%
          </div>
          <div>{{ $t("weMonthlyInsights.monthly.dailyAttendance") }}</div>
        </div>
      </div>
      <div class="flex-center contributions-card">
        <img
          :src="
            require(`@/assets/images/wv-monthly-insights/monthly/${
              contributionsData.feedbackSharedStatus || 'red'
            }/ic_feedback_shared.png`)
          "
          class="big-circle"
        />
        <div class="fs-13 ml-8">
          <div class="fw-700">
            {{
              contributionsData.feedbackShared>0
                ? $utils(
                    "addCommasInNumber",
                    contributionsData.feedbackShared.toFixed(0) || ""
                  )
                : "-"
            }}
          </div>
          <div>{{ $t("weMonthlyInsights.monthly.feedbackShared") }}</div>
        </div>
      </div>
      <div class="flex-center contributions-card">
        <img
          :src="
            require(`@/assets/images/wv-monthly-insights/monthly/${
              contributionsData.recognitionGivenStatus || 'red'
            }/ic_recognition_given.png`)
          "
          class="big-circle"
        />
        <div class="fs-13 ml-8">
          <div class="fw-700">
            {{
              contributionsData.recognitionGiven>0
                ? $utils(
                    "addCommasInNumber",
                    contributionsData.recognitionGiven.toFixed(0) || ""
                  )
                : "-"
            }}
          </div>
          <div>{{ $t("weMonthlyInsights.monthly.recognitionGiven") }}</div>
        </div>
      </div>
      <div class="flex-center contributions-card">
        <img
          :src="
            require(`@/assets/images/wv-monthly-insights/monthly/${
              contributionsData.peerFeedbackStatus || 'red'
            }/ic_peer_feedback.png`)
          "
          class="big-circle"
        />
        <div class="fs-13 ml-8">
          <div class="fw-700">
            {{
              contributionsData.peerFeedback>0
                ? $utils(
                    "addCommasInNumber",
                    contributionsData.peerFeedback.toFixed(0) || ""
                  )
                : "-"
            }}
          </div>
          <div>{{ $t("weMonthlyInsights.monthly.peerFeedback") }}</div>
        </div>
      </div>
      <div class="flex-center contributions-card" v-if="user.boss">
        <img
          :src="
            require(`@/assets/images/wv-monthly-insights/monthly/${
              contributionsData.managerReplyRateStatus || 'red'
            }/ic_manager_reply_rate.png`)
          "
          class="big-circle"
        />
        <div class="fs-13 ml-8">
          <div class="fw-700">
            {{
              contributionsData.managerReplyRate>0
                ? $utils(
                    "addCommasInNumber",
                    contributionsData.managerReplyRate.toFixed(0) || ""
                  )
                : "-"
            }}%
          </div>
          <div>{{ $t("weMonthlyInsights.monthly.managerReplyRate") }}</div>
        </div>
      </div>
      <div class="flex-center contributions-card" v-if="user.boss">
        <img
          :src="
            require(`@/assets/images/wv-monthly-insights/monthly/${
              contributionsData.insightsOpenedStatus || 'red'
            }/ic_insights_opened.png`)
          "
          class="big-circle"
        />
        <div class="fs-13 ml-8">
          <div class="fw-700">
            {{
              contributionsData.insightsOpened>0
                ? $utils(
                    "addCommasInNumber",
                    contributionsData.insightsOpened.toFixed(0) || ""
                  ) + "%"
                : "-"
            }}
          </div>
          <div>{{ $t("weMonthlyInsights.monthly.insightsOpened") }}</div>
        </div>
      </div>
    </div>

    <div class="mt-40 feeling-sesstion">
      <div class="fs-18 fw-900">
        {{ $t("weMonthlyInsights.monthly.howHaveWe") }}
      </div>
      <div class="upppercase fs-15 fw-700 mt-16">
        {{ user.month }} {{ user.year }}
      </div>
      <div class="flex pt-12 mx-auto" style="width: 716px; min-height: 223px">
        <div class="mr-40">
          <div class="calendar fc-15253C">
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.m_day") }}
            </div>
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.t_day") }}
            </div>
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.w_day") }}
            </div>
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.th_day") }}
            </div>
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.f_day") }}
            </div>
           
            <div
              v-for="(color, index) in youFeeling"
              :key="`${index}-${color}`"
            > 
            
            <img
              :src="getImgUrlYou(color)"
              style="width: 28px;height: 28px;"
            />
          </div>
          </div>
          <div
            v-if="youFeeling.length == 0"
            class="flex-mid"
            style="height: 184px"
          >
            <loading-even></loading-even>
          </div>
          <div class="fs-15 fw-700 center mt-6">
            {{ $t("weMonthlyInsights.monthly.y_you") }}
          </div>
        </div>
        <div class="mr-40" v-if="user.boss">
          <div class="calendar fc-15253C">
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.m_day") }}
            </div>
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.t_day") }}
            </div>
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.w_day") }}
            </div>
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.th_day") }}
            </div>
            <div class="mx-auto day-text">
              {{ $t("weMonthlyInsights.monthly.f_day") }}
            </div>
            <div
              v-for="(color, index) in teamFeeling"
              :key="`${index}-${color}`"
              :style="`border-color: ${color};`"
              class="small-circle"
            ></div>
          </div>
          <div
            v-if="teamFeeling.length == 0"
            class="flex-mid"
            style="height: 184px"
          >
            <loading-even></loading-even>
          </div>
          <div class="fs-15 fw-700 center mt-6">
            {{ $t("weMonthlyInsights.monthly.y_youTeam") }}
          </div>
        </div>
        <div>
          <div class="fc-15253C fs-16" style="line-height: 24px">
            {{
              user.boss
                ? $t("weMonthlyInsights.monthly.overallYourTeam")
                : $t("weMonthlyInsights.monthly.overallYourHad")
            }} <span class="line green">{{ feeling.good ? feeling.good : 0 }} {{ $t("weMonthlyInsights.monthly.good") }}</span
            >&nbsp;
            <span class="line yellow"
            > {{ feeling.okay ? feeling.okay : 0 }} {{ $t("weMonthlyInsights.monthly.justOkay") }}</span
            >&nbsp; {{ $t("weMonthlyInsights.monthly.and") }}&nbsp;<span class="line red"
              > {{ feeling.critical ? feeling.critical : 0 }} {{ $t("weMonthlyInsights.monthly.criticalDays") }}</span
            >
          </div>

          <div class="reminder mt-28 fc-15253C">
            <div class="fs-12 fw-700">
              {{ $t("weMonthlyInsights.monthly.remidner") }}
            </div>
            <div v-if="teamFeeling.length == 0" class="fs-13">
              <div>{{ $t("weMonthlyInsights.monthly.focusOnGetting") }}</div>
              <div class="mt-8">
                {{ $t("weMonthlyInsights.monthly.andYouHave") }}
              </div>
            </div>
            <div v-else class="fs-13">
              {{ $t("weMonthlyInsights.monthly.yourPrimaryRole") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TODO: ADD CONSISTENCY SECTION-->
    <div class="consistency-section">
      <div class="fc-15253C fs-18 fw-900 mt-40">
        {{ $t("weMonthlyInsights.monthly.howconsist") }}
      </div>
      <div class="fc-15253C opa-07 fs-14 mb-8">
        {{ $t("weMonthlyInsights.monthly.consistencycontributions") }}{{ consistent }}% {{ $t("weMonthlyInsights.monthly.consistency") }}
      </div>
      <div class="heatmap">
        <!-- Month Labels -->
        <div class="labels">
          <div v-for="(val) in pastmonth" v-bind:key="val" class="month-label">{{ $t(`weMonthlyInsights.monthly.month_${val}`) }}</div>
            <!-- <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_1") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_2") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_3") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_4") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_5") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_6") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_7") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_8") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_9") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_10") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_11") }}</div>
            <div class="month-label">{{ $t("weMonthlyInsights.monthly.month_12") }}</div> -->
            <!-- ... add labels for all months -->
        </div>

        <!-- Heatmap Grid -->
        <div class="grid">
            <!-- Repeat for each week of the year -->
           
            <div class="week">
                <div class="cell dow">{{ $t("weMonthlyInsights.monthly.m_day") }}</div> <!-- Example for Monday -->
                <div class="cell dow">{{ $t("weMonthlyInsights.monthly.t_day") }}</div>  <!-- Example for Tuesday -->
                <div class="cell dow">{{ $t("weMonthlyInsights.monthly.w_day") }}</div>    <!-- Example for Wednesday -->
                <div class="cell dow">{{ $t("weMonthlyInsights.monthly.th_day") }}</div>    <!-- Example for Thursday -->
                <div class="cell dow">{{ $t("weMonthlyInsights.monthly.f_day") }}</div>     <!-- Example for Friday -->
                <div v-if="alldays" class="cell dow">{{ $t("weMonthlyInsights.monthly.s_day") }}</div> 
                <div v-if="alldays" class="cell dow">{{ $t("weMonthlyInsights.monthly.su_day") }}</div> 
              </div>
            <div v-for="(data, index) in dailyData"  v-bind:key="index" class="week">
              <div v-for="(color, index) in data" v-bind:key="index" :class="`cell ${color}`">
            </div>
            </div>

            <div class="legend">
              <div class="title">Legend:</div>
              <div class='cell very-happy'></div><div class="legend-label">Very Happy</div>
              <div class='cell pretty-good'></div><div class="legend-label">Pretty Good</div>
              <div class='cell just-okay'></div><div class="legend-label">Just Okay</div>
              <div class='cell not-great'></div><div class="legend-label">Not Great</div>
              <div class='cell terrible'></div><div class="legend-label">Terrible</div>
              <div class='cell skip'></div><div class="legend-label">Skipped</div>
              <div class='cell holiday'></div><div class="legend-label">Holiday</div>
            </div>

            <!-- ... -->
        </div>
    </div>
      </div>

    <div class="performing-session">
      <div class="fc-15253C fs-18 fw-900 mt-40">
        {{ $t("weMonthlyInsights.monthly.howAreWe") }}
      </div>
      <div v-if="user.boss" class="fc-15253C opa-07 fs-14 mb-8">
        {{ $t("weMonthlyInsights.monthly.keyAreasOfฺBoss") }}
      </div>
      <div v-else class="fc-15253C opa-07 fs-14 mb-8">
        {{ $t("weMonthlyInsights.monthly.keyAreasOf") }}
      </div>
      <div
        v-if="performingData.length > 0"
        class="font-lato flex-wrap mx-auto"
        style="width: 716px"
      >
        <div
          class="card flex-center"
          v-for="(card, index) in performingData"
          :key="`card-performingData-${index}`"
          :style="`${backgroundColorDimensionCard(card)}`"
        >
          <div class="flex-center">
            <img
              :src="getImgUrl(card.img)"
              class="img-dimension"
              :alt="card.text"
            />
          </div>
          <div class="flex-center fs-12 ml-10 fw-700">{{ card.text }}</div>
          <div
            v-if="card.calulate == 0"
            class="fs-12 fw-700 flex-mid ml-auto value fc-15253C"
          >
            N/A
          </div>
          <div v-else class="flex-mid ml-auto value">
            <div class="fs-12 fw-700 ml-auto" v-if="user.boss">
              {{ card.calulate }}
            </div>
            <img
              v-if="card.status === 'up'"
              :src="$utils('icons', 'arrow_up_green_24dp')"
              alt=""
            />
            <img
              v-else-if="card.status === 'down'"
              :src="$utils('icons', 'arrow_down_red_24dp')"
              alt=""
            />
            <img v-else :src="$utils('icons', 'same_score_24dp')" alt="" />
          </div>
        </div>
      </div>
      <div v-else class="flex-wrap mx-auto" style="width: 716px">
        <div
          class="card flex-center"
          v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="`card-mock-data-${i}`"
          style="background-color: #d8d8d830"
        >
          <div class="flex-center">
            <div
              class="image-skeleton opa-02"
              style="width: 32px; height: 32px; border-radius: 32px"
            ></div>
          </div>
          <div
            class="flex-center text-skeleton ml-10"
            style="height: 14px; width: 100px"
          ></div>
          <div class="flex-mid ml-auto value"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { stat } from "fs";
export default {
  components: {
    loadingEven: require("../even/loading").default,
  },
  props: {
    user: {
      id: String,
      name: String,
      firstname: String,
      lastname: String,
      month: String,
      year: String,
      boss: Boolean,
    },
  },
  mounted() {
    //this.$store.dispatch("monthlyInsignhts/getContributions",this.users);
  },
  created() {
    setTimeout(() => {
      this.lang = localStorage.getItem("lang");
      //this.$store.dispatch("monthlyInsignhts/getContributions",this.user);
      //this.$store.dispatch("monthlyInsignhts/getinsight_team",this.user);
      //this.$store.dispatch("monthlyInsignhts/getPerforming", this.user);
    }, 1000);
  },
  // props: {
  //   dialogStatus: false,
  //   Text: "",
  // },
  data() {
    return {
      lang: "EN",
      // contributionsData: {
      //   dailyAttendance: 95,
      //   dailyAttendanceStatus: "green",
      //   feedbackShared: 5,
      //   feedbackSharedStatus: "yellow",
      //   recognitionGiven: 5,
      //   recognitionGivenStatus: "green",
      //   peerFeedback: 2,
      //   peerFeedbackStatus: "green",
      //   managerReplyRate: 14,
      //   managerReplyRateStatus: "red",
      //   insightsOpened: 92,
      //   insightsOpenedStatus: "green",
      // },
      //feelingPastMonthData: {
      // youFeeling: [
      //   "#DBDBDB",
      //   "#DBDBDB",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#7B7B7B",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#7B7B7B",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#DBDBDB",
      // ],
      // teamFeeling: [
      //   "#DBDBDB",
      //   "#DBDBDB",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#FFBA0D",
      //   "#FFBA0D",
      //   "#FFBA0D",
      //   "#F22F3C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#27BC6C",
      //   "#DBDBDB",
      // ],
      //   good: 18,
      //   okay: 3,
      //   critical: 1
      // },
      // performingData: {
      //   card: [
      //     {
      //       img: "Feedback",
      //       text: "Feedback",
      //       value: 100,
      //       status: "up",
      //     },
      //     {
      //       img: "Recognition",
      //       text: "Recognition",
      //       value: 95,
      //       status: "none",
      //     },
      //     {
      //       img: "Personal-Growth",
      //       text: "Rel. Manager",
      //       value: 95,
      //       status: "up",
      //     },
      //     {
      //       img: "satisfaction",
      //       text: "Satisfaction",
      //       value: 90,
      //       status: "up",
      //     },
      //     {
      //       img: "satisfaction",
      //       text: "Wellness",
      //       value: 80,
      //       status: "up",
      //     },
      //     {
      //       img: "Ambassadorship",
      //       text: "Personal Growth",
      //       value: 70,
      //       status: "up",
      //     },
      //     {
      //       img: "Company-Alignment",
      //       text: "Company Alignment",
      //       value: 68,
      //       status: "down",
      //     },
      //     {
      //       img: "Ambassadorship",
      //       text: "Ambassadorship",
      //       value: 58,
      //       status: "down",
      //     },
      //     {
      //       img: "relationship-with-colleagues",
      //       text: "Rel. Colleagues",
      //       value: 45,
      //       status: "up",
      //     },
      //   ],
      // },
    };
  },
  computed: {
    contributionsData() {
      return this.$store.getters["monthlyEngaged/contributions"];
    },
    youFeeling() {
      return this.$store.getters["monthlyEngaged/youFeeling"];
    },
    teamFeeling() {
      return this.$store.getters["monthlyEngaged/teamFeeling"];
    },
    feeling() {
      return this.$store.getters["monthlyEngaged/feeling"];
    },
    performingData() {
      return this.$store.getters["monthlyEngaged/performingData"];
    },
    dailyData(){
      return this.$store.getters["monthlyEngaged/dailyData"];
    },
    pastmonth(){
      return this.$store.getters["monthlyEngaged/month"];
    },
    consistent(){
      return this.$store.getters["monthlyEngaged/consistent"];
    },
    alldays(){
      return this.$store.getters["monthlyEngaged/alldays"];
    },

  },
  methods: {
    getImgUrl(pic) {
     
      var images = require.context(
        "../../assets/images/wv-monthly-insights/monthly/",
        false,
        /\.png$/
      );
      return images("./" + pic + "@2x.png");
    },
    getImgUrlYou(pic) {

      var images = require.context(
        "../../assets/images/wv-monthly-insights/ring_assets",
        false,
        /\.png$/
      );
      return images("./" + pic );
    },
    backgroundColorDimensionCard(item) {
      const value = item.calulate;
      let color = "#F22F3C12";
      if (value == 0) {
        color = "rgba(0, 0, 0, 0.1)";
      } else if (value > 75) {
        color = "#27BC6C12";
      } else if (value > 50) {
        color = "#FFBA0D12";
      }
      return `background-color: ${color}; `;
    },
    showVideo() {
      this.$emit("dialogValue", {value:true, text: "section-1"})
    }
  },
};
</script>

<style lang="scss" scoped>
.contributions-card {
  padding: 8px;
  width: calc(117px + 36px + 8px);
  > .big-circle {
    width: 36px;
    height: 36px;
    border-radius: 36px;
    background-color: #dbdbdb;
  }
  > .big-circle.green {
    background-color: rgba($color: #27bc6c, $alpha: 0.5);
  }
  > .big-circle.yellow {
    background-color: rgba($color: #ffba0d, $alpha: 0.5);
  }
  > .big-circle.red {
    background-color: rgba($color: #f22f3c, $alpha: 0.5);
  }
}
.feeling-sesstion {
  color: #15253c;
  .calendar {
    display: grid;
    width: 180px;
    padding: 0;
    grid-template-columns: auto auto auto auto auto;
  }
  .day-text {
    font-size: 12px;
    font-weight: 700;
    opacity: 0.5;
    margin-bottom: 4px;
  }
  .small-circle {
    width: 28px;
    height: 28px;
    margin: 4px auto;
    border-radius: 28px;
    background-color: #FFFFFF;
    border-color: #dbdbdb;
    border-width: 7px;
    border-style: solid;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

  }
  .reminder {
    background-color: rgba($color: #000000, $alpha: 0.05);
    border-radius: 4px;
    padding: 16px;
    max-width: 400px;
  }
  .line {
    position: relative;
    white-space: pre;
    font-weight: 700;
    &::before {
      position: absolute;
      content: "";
      bottom: -4px;
      width: 100%;
      height: 4px;
      border-radius: 2px;
    }
  }
  .line.green {
    &::before {
      background-color: #27bc6c;
    }
  }
  .line.yellow {
    &::before {
      background-color: #ffba0d;
    }
  }
  .line.red {
    &::before {
      background-color: #f22f3c;
    }
  }
}
.performing-session {
  color: #15253c;
  .card {
    width: calc(230px - 16px);
    height: 44px;
    border-radius: 4px;
    padding-left: 8px;
    padding-right: 8px;
    margin: 4px;
    .img-dimension {
      width: 32px;
      height: 32px;
    }
    .value {
      width: 52px;
      border-radius: 4px;
      background-color: #ffffff;
      height: 32px;
    }
  }
}
@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.insights-container {
  animation-duration: 1.8s;
  animation-name: opacity;
}

.heatmap {
    display: flex;
    flex-direction: column;
    margin-left: -16px;
}

.labels {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    width: 752px;
    font-size: 12px;
}

.month-label {
    flex-grow: 1;
    text-align: center;
    font-weight: bold;
}

.grid {
    display: flex;
    flex-wrap: wrap;
    width: 752px;
}

.week {
    display: flex;
    flex-direction: column;
    margin-right: 4px;
}

.cell {
    width: 10px;
    height: 10px;
    margin-bottom: 4px;
    border-radius: 2px;
}
.cell.dow {
    font-size: 8px;
    text-align: center;
    color: #AAA;
    margin-right: 8px;
    font-weight: 700;
}

.very-happy { background-color: #27BC6C; }
.pretty-good { background-color: #52E03F; }
.just-okay { background-color: #FFBA0D; }
.not-great { background-color: #FC3D4A; }
.terrible { background-color: #C70C18; }
.skip { background-color: #818181; }
.holiday { background-color: rgba(0,0,0,0.10); }


.legend {
    margin: 16px 0 0 0;
    width: 752px;
    display: flex;
    justify-content: center;
}
.legend div {
    display: flex;
    flex-direction: column;
}
.legend .legend-label {
    line-height: 10px;
    padding: 0 0 0 8px;
    font-size: 12px;
}
.legend .cell {
    margin: 0 0 0 20px;
}
.legend .title {
    font-weight: 700;
    font-size: 14px;
    line-height: 10px;
}
</style>